<template>
  <div class="common-box CustomerManagement">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form common-box-search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <search-form @search="handleSearch" @refresh="handleRefresh">
          <div slot="content">
            <el-form-item label="客户名称：">
              <el-input
                size="mini"
                v-model.trim="form.customerName"
                placeholder="请输入客户名称"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['KHTJ']"
          class="plr28"
          @click="jumpAdd"
          >添加</el-button
        >
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['KHSC']"
          @click="deleteContractMore"
          class="plr28"
          plain
          >删除</el-button
        >
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="customerName"
            label="客户名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="customerPhone"
            label="联系方式"
            width="150"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="customerAddress"
            label="地址"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="nickname"
            label="微信昵称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="propertyUnitName"
            label="关联使用单位"
            width="200"
          ></el-table-column>

          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="202px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['KHBD']"
                @click="handleDetail(scope.row)"
              >
                {{ scope.row.openId ? "解绑" : "绑定" }}
              </el-button>
              <div class="btn-divide" v-if="hasRole['KHBD']"></div>
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['KHBJ']"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <div class="btn-divide" v-if="hasRole['KHBJ']"></div>
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['JTGZ']"
                @click="handleFlow(scope.row)"
                >添加关注</el-button
              >
              <div class="btn-divide" v-if="hasRole['JTGZ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['KHSC']"
                type="text"
                @click="deleteContract(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>

    <AddUser
      v-if="showAddUser"
      :clientForm="userDetail"
      @cancel="showAddUser = false"
      @confirm="finishAddUserConfirm"
    />
    <AddAssigne
      v-if="showBindLift"
      :clientForm="userDetail"
      @cancel="showBindLift = false"
      @confirm="finishBindLiftConfirm"
    />
    <CheckUser v-if="showCode" :url="url" @cancel="showCode = false" />
  </div>
</template>

<script>
import {
  getPageList,
  deleteContract,
  getQRCode,
  unBindWx,
} from "@/api/CustomerManagement";
import QRCode from 'qrcode'
import AddUser from "./components/AddUser.vue";
import CheckUser from "./components/CheckUser.vue";
import AddAssigne from "./components/AddAssigne.vue";

export default {
  name: "CustomerManagement",
  components: {
    AddUser,
    CheckUser,
    AddAssigne
  },
  data() {
    return {
      form: {
        customerName: null,
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      showAddUser: false,
      showBindLift: false,
      userDetail: null,
      showCode: false,
      url: "",
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    getParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      return params;
    },
    async getListData() {
      const params = await this.getParams();
      const res = await getPageList(params);
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(row) {
      this.userDetail = row;
      this.showAddUser = true;
    },
    handleFlow(row) {
      this.userDetail = row;
      this.showBindLift = true;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    deleteContractMore(row) {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      let idList = this.multipleSelection.map((item) => item.id);
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteContract({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteContract(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteContract({ idList: [row.id] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    jumpAdd() {
      this.userDetail = null;
      this.showAddUser = true;
    },
    finishAddUserConfirm(v) {
      this.userDetail = null;
      this.showAddUser = false;
      this.handleSearch();
    },
    finishBindLiftConfirm(v) {
      this.userDetail = null;
      this.showBindLift = false;
      this.handleSearch();
    },
    // 列表排序
    handleSortChange({ column, prop, order }) {
      if (order === "ascending") {
        this.form.sortOrder = "asc";
        this.form.sortField = prop;
      } else if (order === "descending") {
        this.form.sortOrder = "desc";
        this.form.sortField = prop;
      } else {
        this.form.sortField = "";
        this.form.sortOrder = "";
      }
      this.getListData();
    },
    async getQRCodeFun(url) {
      const _myQRCode = await QRCode.toDataURL(url)
      return _myQRCode
    },
    async handleDetail(row) {
      console.log(row);
      if (row.openId) {
        this.$confirm("确定解绑?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const res = await unBindWx(row.id);
            if (res.code === 200) {
              this.$message.success("解绑成功");
              this.getListData();
            }
          })
          .catch((err) => {
            console.log(err);
          });
        return;
      }
      const res = await getQRCode(row.id);
      if (res.code === 200) {
        const url = await this.getQRCodeFun(res.data)
        this.url = url
        // this.imgSrc = url;
        // this.url = window.URL.createObjectURL(res);
        this.showCode = true;
      } else {
        this.$message.warning("二维码请求错误");
      }
    },
  },
};
</script>

<style lang="scss">
.CustomerManagement {
  .el-radio-group {
    margin-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CustomerManagement/CustomerManagement.vue